import React from 'react';
import Toast from 'react-bootstrap/Toast';
import { useToast } from '../../contexts';

const Toasts = () => {
    const { toast, showToast } = useToast();

    return (
        <Toast show={toast.show} onClose={() => showToast('', '', 0, false)} delay={toast.delay} autohide={toast.autohide} >
            <Toast.Header>
                {/* <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" /> */}
                <strong className="me-auto toats-title">{toast.title}</strong>
                {/* <small>just now</small> */}
            </Toast.Header>
            <Toast.Body>{toast.message}</Toast.Body>
        </Toast>
    );
};

export default Toasts;
